export default __webpack_public_path__ + "static/media/logo.035f1767.png";